import type { ReactNode } from "react";
import { RightPanelGradientBackground } from "./RightPanelGradientBackground";
import { WhiteBorderWrapper } from "./WhiteBorderWrapper";

interface RightPanelProps {
  children: ReactNode;
}

export const RightPanel = ({ children }: RightPanelProps) => (
  <WhiteBorderWrapper>
    <RightPanelGradientBackground>
      <div className="w-full lg:max-w-md xl:max-w-lg">{children}</div>
    </RightPanelGradientBackground>
  </WhiteBorderWrapper>
);
